<template>
  <div class="pb-3">
    <h2 id="api_intro">Введение</h2>
    <section class="pt-2">
      API предоставляет возможность выполнения любых действий через собственные приложения.<br>
      Текущая версия расположена по адресу <a target="_blank" :href="url">{{ url }}</a><br>
      <br>
      С помощью API можно выполнять все операции, доступные через наш портал:
      <ul>
        <li>управление пользователями, задачами, контактами и категориями;</li>
        <li>получение статистики.</li>
      </ul>
      API всегда возвращает ответ в формате JSON.
    </section>
    <h4 class="pt-3 pb-2">Коды ответа</h4>
    <section>
      <ul>
        <li>200 - запрос выполнен успешно;</li>
        <li>401 - ошибка авторизации;</li>
        <li>422 - ошибка при проверке входных параметров.</li>
      </ul>
    </section>
    <h4 class="pt-1 pb-2">Авторизация</h4>
    <section>
      Для авторизации необходимо передавать заголовок <code>Authorization: Bearer {{ token }}</code>
    </section>
  </div>
</template>

<script>
  export default {
    props: ['url', 'token']
  }
</script>